import { MemberAutogiroStatusRequest } from 'src/modules/member/models/memberAutogiroStatusRequest';
import { MemberAutogiroStatus } from 'src/modules/invoice/models/memberAutogiroStatus';
import { MemberAutogiroStatusResponse } from 'src/modules/member/models/memberAutogiroStatusResponse';
import AxiosInstance from './axios/interceptor';
import { PagedResult } from '../models/pagedResult';

const controller = 'MemberAutogiroStatus';

export const getAllMemberAutogiroStatus = (searchFilter: MemberAutogiroStatus) => {
  return AxiosInstance.get<PagedResult<MemberAutogiroStatusResponse>>(controller, { params: searchFilter });
};

export const createMemberAutogiroStatus = (data: MemberAutogiroStatusRequest) => {
  const endpoint = `${controller}`;
  return AxiosInstance.post<MemberAutogiroStatusRequest>(endpoint, data);
};

export const deleteMemberAutogiroStatus = (autogiroStatusId: number) => {
  const endpoint = `${controller}/${autogiroStatusId}`;
  return AxiosInstance.delete(endpoint);
};
